import { MessageService } from './../../../_theme/components/message/message.service';
import { Component, OnInit } from "@angular/core";
import { ProfileService } from "src/app/_template/_components/profile/profile.service";
import { Usuario } from "src/app/_models/profile";
import { HelpService } from 'src/app/_services/help.service';
import { LoginService } from 'src/app/_services/login.service';

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"]
})
export class ProfileComponent implements OnInit {
  loading = false ;
  info: Usuario;
  message:MessageService;
  imgUrl: string = '';

  constructor (
    public profileService: ProfileService,
    private helpService: HelpService,
    private loginService: LoginService
  ) {
    this.info = new Usuario();
    this.loading = true;
  }

  ngOnInit() {
    // this.helpService.getHelp();
    this.profileService.onGetUser(sessionStorage.getItem('sysUserId')).subscribe(resp => {
      this.info = resp;
      this.imgUrl = (this.info.enlargedPhoto) ? 'data:image/png;base64,'+ this.info.enlargedPhoto : '';
      this.loading =  false;
    });
  }
}
